import httpClient from './httpClient';
const downloadService = {
    checkDownloadToken(data, config) {
        return httpClient.post('/api/adv/download/token', data, config);
    },
    downloadFromToken(data, config) {
        return httpClient.post('/api/adv/download', data, config);
    },
    downloadDocument(id) {
        return httpClient.get('/api/v2/documents/download/' + id,  {
            responseType: 'arraybuffer'
          });
    }
}

export default downloadService;